import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './Finder.translations'
import type { FinderCriterionConfig } from './Finder.types'

export function getFinderCriteria(
  i18n: ReturnType<typeof useI18n>,
): FinderCriterionConfig[] {
  return [
    {
      criterion: 'usage',
      title: i18n(translations.criterionUsageTitle),
    },
    {
      criterion: 'budget',
      title: i18n(translations.criterionBudgetTitle),
    },
    {
      criterion: 'size',
      title: i18n(translations.criterionSizeTitle),
    },
    {
      criterion: 'conditions',
      title: i18n(translations.criterionConditionTitle),
    },
    {
      criterion: 'requirements',
      title: i18n(translations.criterionRequirementsTitle),
    },
  ]
}
